<template>
	<div id="swagger-ui"></div>
</template>

<script>
export default {
	mounted() {
		const ui = window.SwaggerUIBundle({
			url: '/swagger.yml',
			dom_id: '#swagger-ui',
			presets: [window.SwaggerUIBundle.presets.apis],
			useUnsafeMarkdown: true,
			onComplete: () => {
				if (this.sharedState.user.id_token) {
					ui.preauthorizeApiKey(
						'id_token',
						this.sharedState.user.id_token
					)
				}
			},
		})
	},
}
</script>
